import { useContext, useEffect, useState } from "react";
import { LoaderContext } from "../../../../context/LoaderContext";
import { START_LOADER, STOP_LOADER } from "../../../../constants";
import { momentTimeFormater } from "../../../../utils/timeHelper";
import CustomTooltip from "../../../../components/CustomToolTip/CustomTooltip";
import { UilFileLandscapeAlt, UilLightbulbAlt, UilInfoCircle, UilSync } from '@iconscout/react-unicons';
import Typography from "../../../../components/Typography/Typography";
import Table from "../../../../components/Table/Table";
import ModalComponent from "../../../../components/ModalComponent/ModalComponent";
import CommandLogsModal from "./CommandLogsModal";
import DataLogModal from "./DataLogModal";
import classes from '../../../../styles/AllDevices.module.css';
import monitoringClasses from './index.module.css';
import { EventsService } from "../../../../services/EventsService";
import { AdminService } from "../../../../services/AdminService";
import EventsLogModal from "./EventsLogModal";
import moment from "moment";
import { DropdownComponent } from "../../../../components/Inputs/Input";
import DateRangePicker from '../../../../components/Inputs/DateRangePicker/DateRangePicker';

const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

const LIMIT = 15;
const defaultValue = {
    label: 'All',
    value: 'all',
};

const HistoryEvents = ({ admins, updateQueryParams, queryParamsData }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [events, setEvents] = useState([]);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [dateRange, setDateRange] = useState({
        startDate: queryParamsData.dateRange ? new Date(queryParamsData.dateRange.startDate) : yesterday,
        endDate: queryParamsData.dateRange ? new Date(queryParamsData.dateRange.endDate) : today,
    });
    const [eventsLogModal, setEventsLogModal] = useState({ status: false, id: '' });
    const [commandLogModal, setCommandLogModal] = useState({ status: false, id: '' });
    const [dataLogModal, setDataLogModal] = useState({ status: false, data: '' });
    const [selectedAdmin, setSelectedAdmin] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState(
        queryParamsData.customer
            ? JSON.parse(queryParamsData.customer)
            : defaultValue
    );
    const [customers, setCustomers] = useState([defaultValue]);

    useEffect(() => {
        if (selectedCustomer?.value) {
            getEvents();
        }
    }, [selectedCustomer?.value]);

    useEffect(() => {
        setSelectedAdmin(queryParamsData.admin ? JSON.parse(queryParamsData.admin) : admins[0]);
    }, [admins]);

    useEffect(() => {
        if (selectedAdmin?.value && selectedAdmin?.value !== 'all') {
            getCustomers();
        } else if (selectedAdmin?.value === 'all') {
            setSelectedCustomer(defaultValue);
            setCustomers([defaultValue]);
        }
    }, [selectedAdmin]);

    const getCustomers = () => {
        AdminService.GetCustomers(selectedAdmin?.value, startLoader, handleGetCustomerSuccess, handleError, stopLoader);
    };

    const handleGetCustomerSuccess = ({ data }) => {
        let temp = [
            {
                label: 'All',
                value: 'all',
            },
        ];
        data.data.map((c) => {
            temp.push({
                label: c.name,
                value: c._id,
            });
        });
        setCustomers(temp);
    };

    const getEvents = () => {
        EventsService.GetEvents(
            {
                startDate: momentTimeFormater(moment(dateRange.startDate).format('YYYY-MM-DD')).startOf('day').toDate(),
                endDate: momentTimeFormater(moment(dateRange.endDate).format('YYYY-MM-DD')).endOf('day').toDate(),
                skip,
                limit: LIMIT,
                customerId: selectedCustomer.value
            },
            () => startLoader('getEvents'),
            handleGetEventsSuccess,
            handleError,
            () => stopLoader('getEvents')
        );
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetEventsSuccess = ({ data }) => {
        const processedData = data?.data?.events?.map((item, index) => {
            return {
                's.no': index + 1,
                customerName: item.customerName,
                instanceName: item.instanceName,
                edgeId: item.edgeId,
                status: item.status,
                startSOC: item.startSOC ?? '--',
                endSOC: item.endSOC ?? '--',
                startTime: item.startTime ? momentTimeFormater(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                endTime: item.endTime ? momentTimeFormater(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                action: (
                    <div className={monitoringClasses.ActionContainer}>
                        <div onClick={() => {
                            setEventsLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Event Logs'}>
                                <UilFileLandscapeAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => {
                            setCommandLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Command Logs'}>
                                <UilLightbulbAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => setDataLogModal({ status: true, data: item })}>
                            <CustomTooltip content={'Data Log'}>
                                <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                    </div>
                )
            };
        });
        setEvents(processedData);
        setTotalCount(data?.data?.totalCount || 0)
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div >
            <div className={monitoringClasses.Filter}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className={monitoringClasses.FilterContainer}>
                        <div>
                            <div className={classes.FieldControl}>
                                <label>Select Admin</label>
                                <DropdownComponent
                                    name="adminId"
                                    options={admins}
                                    defaultValue={selectedAdmin}
                                    onChange={(e) => {
                                        setSelectedAdmin(e);
                                        updateQueryParams('admin', JSON.stringify(e));
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <div className={classes.FieldControl}>
                                <label>Select Customer</label>
                                <DropdownComponent
                                    name="customerId"
                                    options={customers}
                                    defaultValue={selectedCustomer}
                                    onChange={(e) => {
                                        if (e.value !== selectedCustomer?.value) {
                                            setSelectedCustomer(e);
                                        }
                                        updateQueryParams('customer', JSON.stringify(e));
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={monitoringClasses.FilterContainer}>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1vw', alignItems: 'flex-end' }}>
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className={classes.DateLabels}>Start Date</div>
                                <div className={classes.DateLabels} style={{ marginRight: '2.604vw' }}>
                                    End Date
                                </div>
                            </div>
                            <DateRangePicker
                                startDate={dateRange.startDate}
                                endDate={dateRange.endDate}
                                onChange={(date) => {
                                    const data = { startDate: new Date(date.startDate), endDate: new Date(date.endDate) };
                                    setDateRange(data);
                                    updateQueryParams('dateRange', JSON.stringify(data));
                                }}
                            />
                        </div>
                        <div
                            className={classes.SubmitButton}
                            onClick={() => {
                                getEvents();
                                setPage(0);
                            }}
                        >
                            <button className="btn-primary" style={{ marginTop: '1.2vw' }}>
                                Submit
                            </button>
                        </div>
                        <div onClick={() => {
                            getEvents();
                        }}>
                            <CustomTooltip content={'Refresh'}>
                                <UilSync size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                            </CustomTooltip>
                        </div>
                    </div>
                </div>

            </div>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content={`History`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={events.length} />
                            </span>
                        </div>
                    </div>
                </div>
                <Table
                    head={[
                        'Customer',
                        'Instance',
                        'Edge ID',
                        'Event Status',
                        'Start SOC',
                        'End SOC',
                        'Start Time (CET)',
                        'End Time (CET)',
                        'Actions'
                    ]}
                    keys={[
                        'customerName',
                        'instanceName',
                        'edgeId',
                        'status',
                        'startSOC',
                        'endSOC',
                        'startTime',
                        'endTime',
                        'action'
                    ]}
                    data={events}
                    page={page}
                    Pagination={true}
                    limit={LIMIT}
                    handlePageChange={handlePageChange}
                    totalCount={totalCount}
                />
            </div>
            <ModalComponent isOpen={eventsLogModal.status} setOpen={() => setEventsLogModal({
                status: false,
                id: '',
            })}>
                <EventsLogModal setOpen={() => setEventsLogModal({ status: false, id: '' })} id={eventsLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={commandLogModal.status} setOpen={() => setCommandLogModal({
                status: false,
                id: '',
            })}>
                <CommandLogsModal setOpen={() => setCommandLogModal({ status: false, id: '' })} id={commandLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={dataLogModal.status} setOpen={() => setDataLogModal({
                status: false,
                data: '',
            })}>
                <DataLogModal setOpen={() => setDataLogModal({ status: false, data: '' })} data={dataLogModal.data} />
            </ModalComponent>
        </div>
    )
}

export default HistoryEvents;